'use strict';
import React, { PureComponent } from 'react';
import RegistroProceso from './RegistroProceso';

class Procesos extends PureComponent {
    constructor(props) {
        super(props);
    }



    render() {
        const {
            comboProceso,
            datosCombo,
            estaDesplegado,
            hayProcesosEnEjecucion,
            habilitarEjecucionReconta
        } = this.props;

        //ACTIONS
        const { 
            cambiarValorCombo,
            cargarRegistrosDatosEjecucion
        } = this.props;

        const registrosArray = [];
        const optionsContabilizadorRecontabilizadorSelect = [];

        datosCombo.map((reg) => {
            let descripcionOption = reg.Descripcion;
                if(datosCombo) {
                    registrosArray.push(<RegistroProceso 
                                            cargarRegistrosDatosEjecucion={cargarRegistrosDatosEjecucion}

                                            key={reg.Nombre} 
                                            registro={reg}
                                            hayProcesosEnEjecucion={hayProcesosEnEjecucion}
                                        />);

                    optionsContabilizadorRecontabilizadorSelect.push(
                        <option key={reg.Nombre} value={reg.Nombre}>
                                {descripcionOption}
                        </option>
                    );
                } 
            }
        );

        return (
            <div className={"ContabilizadorRecontabilizador__contenedorRegistroProceso slider-tarjetas" + (estaDesplegado ? "" : " closed")}>
                <div className="ContabilizadorRecontabilizador__contenedorContabilizadorSelect">
                    <div className="seccionDatosGenerales__tituloSecundario">Se ejecutará el procesamiento desde el proceso</div>

                    <div className="seccionDatosGenerales__contenedorSelectSucursal">
                        <select name="contabilizadorSelect" 
                                onChange={(event) => habilitarEjecucionReconta || !hayProcesosEnEjecucion ? cambiarValorCombo("comboProceso", event.target.value) : null}
                                className={"seccionDatosGenerales__inputSelect ContabilizadorRecontabilizador__contabilizadorSelect" + ((habilitarEjecucionReconta && !hayProcesosEnEjecucion) ? "" : " ContabilizadorRecontabilizador__botonDeshabilitado")}
                                value={comboProceso}
                                disabled={!habilitarEjecucionReconta || hayProcesosEnEjecucion}>
                            {optionsContabilizadorRecontabilizadorSelect}
                        </select>
                    </div>
                </div>

                <div>
                    {registrosArray}
                </div>
            </div>
        );
    }
}

export default Procesos;